import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "hidden-sm-and-down" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "mute" }
const _hoisted_5 = { class: "links" }
const _hoisted_6 = { class: "mr-5" }
const _hoisted_7 = {
  href: "https://www.youtube.com/channel/UCdBYe2r5Sg9IjMFvn6I7KJw",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mr-5" }
const _hoisted_10 = {
  href: "https://www.facebook.com/lipsurfapp/",
  target: "_blank"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "mr-5" }
const _hoisted_13 = {
  href: "https://twitter.com/lipsurfapp",
  target: "_blank"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  href: "https://github.com/lipsurf",
  target: "_blank"
}
const _hoisted_16 = ["src"]

import { ref, } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

let drawer = ref(false)
const menu = [
  { internal: true, link: 'updates', name: 'What\'s New' },
  { internal: true, link: 'pricing', name: 'Get Premium' },
  { internal: false, link: 'docs.lipsurf.com', name: 'Developers' },
  { internal: false, link: 'discuss.lipsurf.com', name: 'Forum' },
]

return (_ctx: any,_cache: any) => {
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_header = _resolveComponent("v-list-item-header")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_overlay, {
      modelValue: _unref(drawer),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : drawer = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_navigation_drawer, {
      fixed: "",
      app: "",
      modelValue: _unref(drawer),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : drawer = $event)),
      "disable-resize-watcher": "",
      class: "side-nav"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, { to: { name: 'landing' } }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Home")
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (item.internal)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      to: { name: item.link },
                      key: item.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createBlock(_component_v_list_item, {
                      href: 'https://' + item.link,
                      key: item.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["href"]))
              ], 64))
            }), 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_app_bar, {
      flat: "",
      color: "transparent",
      absolute: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_app_bar_nav_icon, {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_isRef(drawer) //@ts-ignore
 ? drawer.value = !_unref(drawer) : drawer = !_unref(drawer)), ["stop"])),
                  class: "hidden-md-and-up",
                  alt: "navigation drawer"
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'landing' },
                  title: "LipSurf Home",
                  class: "logo hidden-sm-and-down"
                }),
                _createVNode(_component_v_spacer),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (item.internal)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              class: "nav-hor-a",
                              key: item.name,
                              to: { name: item.link }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("a", {
                              class: "nav-hor-a",
                              key: item.name,
                              href: 'https://' + item.link
                            }, _toDisplayString(item.name), 9, _hoisted_3))
                      ], 64))
                    }), 64))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, { style: {"overflow-x":"hidden","padding-top":"64px"} }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _renderSlot(_ctx.$slots, "outer")
      ]),
      _: 3
    }),
    _createElementVNode("footer", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", null, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("h5", null, "Product", -1)),
            (_ctx.$route.name !== 'dragon')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'dragon' }
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Comparison with Dragon NaturallySpeaking ")
                  ])),
                  _: 1,
                  __: [4]
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name !== 'updates')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'updates' }
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("What's New ")
                  ])),
                  _: 1,
                  __: [5]
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name !== 'enterprise')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: { name: 'enterprise' }
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Enterprise ")
                  ])),
                  _: 1,
                  __: [6]
                }))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("a", { href: "https://help.lipsurf.com" }, "Help", -1)),
            (_ctx.$route.name !== 'pricing')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: { name: 'pricing' }
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Pricing ")
                  ])),
                  _: 1,
                  __: [7]
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("section", null, [
          _createElementVNode("div", null, [
            _createElementVNode("h5", null, "Developers"),
            _createElementVNode("a", { href: "https://blog.lipsurf.com" }, "Documentation"),
            _createElementVNode("a", { href: "https://github.com/lipsurf" }, "Github"),
            _createElementVNode("a", { href: "https://discuss.lipsurf.com/c/plugin-development" }, "Support")
          ])
        ], -1)),
        _createElementVNode("section", null, [
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("h5", null, "Company", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("a", { href: "https://blog.lipsurf.com" }, "Blog", -1)),
            _createVNode(_component_router_link, { to: { name: 'contact' } }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Contact Us")
              ])),
              _: 1,
              __: [10]
            }),
            _createVNode(_component_router_link, { to: { name: 'tos' } }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Terms of Service")
              ])),
              _: 1,
              __: [11]
            }),
            _createVNode(_component_router_link, { to: { name: 'privacy' } }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Privacy")
              ])),
              _: 1,
              __: [12]
            })
          ])
        ])
      ]),
      _createVNode(_component_v_row, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/youtube-icon.png'),
                    loading: "lazy",
                    width: "28",
                    height: "28",
                    title: "YouTube channel"
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", _hoisted_10, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/fb-icon.png'),
                    loading: "lazy",
                    width: "28",
                    height: "28",
                    title: "Facebook page"
                  }, null, 8, _hoisted_11)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/twitter-icon.png'),
                    loading: "lazy",
                    width: "28",
                    height: "28",
                    title: "Twitter account"
                  }, null, 8, _hoisted_14)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_15, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/github-icon.png'),
                    loading: "lazy",
                    width: "28",
                    height: "28",
                    title: "Github account"
                  }, null, 8, _hoisted_16)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"margin":"2em"} }, "© 2018-2026 LipSurf Inc.", -1))
    ])
  ]))
}
}

})